import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { isEmpty } from "lodash";

async function create(data) {
  const response = await http
    .postData("/nihss-assessment", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function update(id, data) {
  const response = await http
    .putData(`/nihss-assessment/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http
    .getData(`/register/${register_id}/nihss-assessment`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`/nihss-assessment/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signDokter(id: number, data) {
  const response = await http
    .putData(`/nihss-assessment/${id}/sign-dokter`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signByRegister(registerId: string | number, data) {
  const response = await http
    .putData(`/register/${registerId}/nihss-assessment/sign-dokter`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/nihss-assessment/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return isEmpty(response?.data) ? null : response.data;
}

function print(registerId) {
  window.open(`${http.getAPI()}/register/${registerId}/nihss-assessment/pdf`, "_blank");
}

export default {
  create,
  update,
  getByRegister,
  find,
  signDokter,
  signByRegister,
  destroy,
  print
};
